export default __webpack_public_path__ + "d6a977e1510fc6a8e910521dc5d0b53d.ttf";